import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ContentBuilderColorValue } from '@core/models/content-builder-fields.model';
import { ContentBuilderColorPipe } from '@core/pipes/content-builder-color.pipe';

//? I think the modal button should be another component
//? It does not provided secondary colors
//? the type and color inputs are a bit confusing
@Component({
  selector: 'app-button-atom',
  templateUrl: './button-atom.component.html',
  styleUrls: ['./button-atom.component.scss'],
  imports: [ContentBuilderColorPipe],
})
export class ButtonAtomComponent {
  @Input() type:
    | 'primary'
    | 'light'
    | 'outlined'
    | 'link'
    | 'danger'
    | 'kiosk-primary'
    | 'kiosk-light'
    | 'kiosk-outlined' = 'primary';
  @Input() label!: string;
  @Input() icon!: string;
  @Input() iconUrl!: string | undefined;
  @Input() size: 'XXL' | 'XL' | 'L' | 'M' | 'S' | 'XS' | 'inherit' | (string & {}) = 'S';
  @Input() thickSize: 'XS' | 'S' | 'M' | 'L' | 'inherit' | (string & {}) = 'M';
  @Input() iconOnRight = false;
  @Input() disabled = false;
  @Input() lookDisabled = false;
  @Input() full = false;
  @Input() link?: string;
  @Input() iconRotation: '0' | '90' | '180' | '270' = '0';
  @Input() aspectSquare = false;
  // color works for light type only
  @Input() color: 'neutral' | 'success' | 'primary' | 'info' | 'highligh' = 'primary';
  @Input() overrideBgColor?: ContentBuilderColorValue;
  @Input() overrideTextColor?: ContentBuilderColorValue;
  // classContent is used to pass the class from the parent component, helpful for passing padding, margin, etc.
  @Input() classContent = '';

  protected colorFieldRawValue(color?: ContentBuilderColorValue): string | undefined {
    if (typeof color === 'string') {
      return color || undefined;
    }

    return color?.value;
  }

  protected hasColorFieldValue(color?: ContentBuilderColorValue): boolean {
    return Boolean(this.colorFieldRawValue(color));
  }

  @Output() clickEventEmitter = new EventEmitter<any>();
}
